// @ constants
const { EURO_SYMBOL, EURO_TEXT } = require('constants/index');

// @ helpers
const { formatText } = require('core/i18n').i18n;

module.exports = {

    getTitleLabel(titleAmount) {
        if (titleAmount === 1) {
            return formatText('broker-titleLabel');
        } else {
            return formatText('broker-titlesLabel');
        }
    },

    getCurrencySimbol(currency){
        if (currency === EURO_TEXT) {
            return EURO_SYMBOL;
        } else {
            return currency;
        }
    }
};